export const ZAR8_LOCAL_ICON_PATH = "/figma/zar8-yield/zar8-icon.png";

export interface BusinessWalletPresentationAsset {
  asset?: string | null;
  assetId?: string | number | null;
  assetName?: string | null;
  assetIcon?: string | null;
  image?: string | null;
  symbol?: string | null;
  info?: {
    asset?: string | null;
  };
}

export interface AssetIconSources {
  src: string;
  fallbackSrc?: string;
}

function cleanString(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

export function getBusinessWalletAssetCode(
  asset?: BusinessWalletPresentationAsset | null
): string {
  const rawCode =
    asset?.asset ??
    asset?.symbol ??
    asset?.info?.asset ??
    asset?.assetId ??
    asset?.assetName ??
    "";

  return String(rawCode).trim().toUpperCase();
}

export function isBusinessWalletZar8Asset(
  asset?: BusinessWalletPresentationAsset | null
): boolean {
  const assetCode = getBusinessWalletAssetCode(asset);
  const assetName = cleanString(asset?.assetName).toUpperCase();

  return assetCode === "ZAR8" || assetName.includes("ZAR8");
}

export function resolveBusinessWalletAssetIcon(
  asset?: BusinessWalletPresentationAsset | null
): AssetIconSources {
  const metadataIcon =
    cleanString(asset?.image) || cleanString(asset?.assetIcon);

  if (isBusinessWalletZar8Asset(asset)) {
    return {
      src: ZAR8_LOCAL_ICON_PATH,
    };
  }

  return { src: metadataIcon };
}

export function getBusinessSuiteAssetPath(
  asset: BusinessWalletPresentationAsset
): string {
  const params = new URLSearchParams();
  const assetCode = getBusinessWalletAssetCode(asset);

  if (assetCode) {
    params.set("asset", assetCode);
  }

  const query = params.toString();
  return query ? `/trading/business-suite?${query}` : "/trading/business-suite";
}
